import { fetchGet, fetchPost, fetchPatch } from "@/lib/services";

export async function getLeads(search: string, page: number) {
  const params = new URLSearchParams();
   if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());

  return await fetchGet(`/mlbwebdataget/?${params.toString()}`);
}

export async function createLeadRemark(data: { Requested_user: number; Remarks: string }) {
  return await fetchPost("/mlbwebdataget/", data);
}

export async function getLeadRemarks(userId: number,page:number) {
  return await fetchGet(`/mlbwebdataget/?Request_user=${userId}&Page=${page}`);
}

export async function updateLead(id: number, data: {
  Lead_Status_Date: string;
  Lead_Status: number;
  Lead_Status_Remarks: string;
  State: string;
}) {
    const params = new URLSearchParams();

  return await fetchPatch(`/mlbwebdataget/?Id=${id}`, data);
}
